import { Col } from "react-bootstrap";
import { BiLogoTelegram } from "react-icons/bi";
import { FaPhone } from "react-icons/fa";
import { FaFacebook, FaLocationDot, FaXTwitter } from "react-icons/fa6";
import { GrLinkedin } from "react-icons/gr";
import { MdEmail } from "react-icons/md";
import { SiInstagram } from "react-icons/si";
import { Link } from "react-router-dom";
import myketLogo from "../../../assets/pic/get1-fa.svg";
import "./footer.css";

const Footer = () => {
  return (
    <>
      <footer style={{ marginTop: 80 }} className="parallax">
        <div
          dir="rtl"
          className="py-5 position-relative"
          style={{ zIndex: 190 }}
        >
          <div
            className="d-flex flex-row flex-wrap justify-content-center justify-content-md-start"
            style={{ paddingInline: "5%" }}
          >
            <Col lg={3} md={4} sm={10} xs={10} style={{ color: "white" }}>
              <h5 className="mb-3">دسترسی سریع</h5>
              <hr className="w-75" />
              <ul className="nav flex-column pe-1">
                <li className="mb-3">
                  <Link to="/register">ثبت نام</Link>
                </li>
                <li className="mb-3">
                  <Link to="/preinternal">ثبت سفارش داخلی</Link>
                </li>
                <li className="mb-3">
                  <Link to="/preexternal">ثبت سفارش خارجی</Link>
                </li>
                <li className="mb-3">
                  <Link to="/preagent">اخذ نمایندگی</Link>
                </li>
                <li className="mb-3">
                  <Link to="/agent-list">نمایندگان ما</Link>
                </li>
                <li>
                  <Link to="/developers">توسعه دهندگان</Link>
                </li>
              </ul>
            </Col>

            <Col lg={3} md={4} sm={10} xs={10} style={{ color: "white" }}>
              <h5 className="mb-3 ">لینک</h5>
              <hr className="w-75" />

              <ul className=" nav flex-column pe-1">
                <li className="mb-3">
                  <Link to="/rules">قوانین</Link>
                </li>
                <li className="mb-3">
                  <Link to="/contact">ارتباط با ما</Link>
                </li>
                <li className="mb-3">
                  <Link to="/support">پشتیبانی (تیکت)</Link>
                </li>
                <li className="mb-3">
                  <Link to="/about">درباره ما</Link>
                </li>
              </ul>
            </Col>

            <Col lg={3} md={4} sm={10} xs={10} style={{ color: "white" }}>
              <h5 className="mb-3 ">تماس با آواکس</h5>
              <hr className="w-75" />

              <ul className=" nav flex-column pe-1">
                <li className="mb-3">
                  <h6 className="text-end">
                    <FaPhone
                      style={{ height: 20, width: 20 }}
                      className="ps-2"
                    />
                    <Link to="tel:02182802466">021-82802466</Link>
                  </h6>
                </li>
                <li className="mb-3 w-75">
                  <FaLocationDot
                    style={{ height: 20, width: 20 }}
                    className="ps-2"
                  />
                  مشهد بلوار شهید قرنی چهارراه مجد برج اداری اطمینان طبقه هشتم و
                  احد 805
                </li>
                <li className="mb-3">
                  <h6>
                    <MdEmail
                      style={{ height: 25, width: 25 }}
                      className="ps-2"
                    />
                    info@avaex.ir
                  </h6>
                </li>
              </ul>
            </Col>

            <Col lg={3} md={4} sm={10} xs={10} style={{ color: "white" }}>
              <h5 className="mb-3">شبکه های اجتماعی</h5>
              <hr className="w-75" />
              <ul className="nav flex-row pe-1">
                <li className="mb-3">
                  <Link to="https://instagram.com/avaex.ir" target="_blank">
                    <SiInstagram
                      style={{
                        color: "white",
                        width: 25,
                        height: 25,
                        marginLeft: 20,

                        cursor: "pointer",
                      }}
                    />
                  </Link>
                </li>
                <li className="mb-3">
                  <Link to="https://www.linkedin.com/in/avaex" target="_blank">
                    <GrLinkedin
                      style={{
                        color: "white",
                        width: 25,
                        height: 25,
                        marginLeft: 20,
                        cursor: "pointer",
                      }}
                    />
                  </Link>
                </li>
                <li className="mb-3">
                  <Link to="https://www.facebook.com/avaex.exp" target="_blank">
                    <FaFacebook
                      style={{
                        color: "white",
                        width: 25,
                        height: 25,
                        marginLeft: 20,
                        cursor: "pointer",
                      }}
                    />
                  </Link>
                </li>
                <li className="mb-3">
                  <Link to="https://x.com/avaex_exp" target="_blank">
                    <FaXTwitter
                      style={{
                        color: "white",
                        width: 25,
                        height: 25,
                        marginLeft: 20,
                        cursor: "pointer",
                      }}
                    />
                  </Link>
                </li>
                <li className="mb-3">
                  <Link to="https://t.me/avaexpublic" target="_blank">
                    <BiLogoTelegram
                      style={{
                        cursor: "pointer",
                        color: "white",
                        width: 25,
                        height: 25,
                        marginLeft: 20,
                      }}
                    />
                  </Link>
                </li>
              </ul>

              <Link
                to="https://myket.ir/app/com.example.avaex"
                target="_blank"
                className="d-flex mt-4"
              >
                <img
                  src={myketLogo}
                  alt="مایکت"
                  style={{ width: 200, objectFit: "contain" }}
                />
              </Link>
            </Col>
          </div>

          <div
            className="d-flex flex-wrap flex-row-reverse gap-3"
            style={{ paddingInline: "5%" }}
          >
            <Col xxl={1} lg={2} md={3} xs={5}>
              <img
                referrerPolicy="origin"
                id="rgvjfukzrgvjnbqejzpeesgt"
                className="c-pointer object-fit-contain"
                onClick={() =>
                  window.open(
                    "https://logo.samandehi.ir/Verify.aspx?id=363270&p=xlaogvkaxlaouiwkjyoeobpd",
                    "Popup",
                    "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
                  )
                }
                alt="logo-samandehi"
                src="https://logo.samandehi.ir/logo.aspx?id=363270&p=qftiwlbqqftiodrfyndtlyma"
              />
            </Col>

            <Col xxl={1} lg={2} md={3} xs={5}>
              <Link
                referrerPolicy="origin"
                target="_blank"
                to="https://trustseal.enamad.ir/?id=330017&Code=C97G7U7A3MDGlltvGbdE"
              >
                <img
                  referrerPolicy="origin"
                  src="https://trustseal.enamad.ir/logo.aspx?id=330017&Code=C97G7U7A3MDGlltvGbdE"
                  alt="اینماد"
                  className="c-pointer object-fit-contain"
                  code="C97G7U7A3MDGlltvGbdE"
                />
              </Link>
            </Col>

            <Col xxl={1} lg={2} md={3} xs={5}>
              <Link
                referrerPolicy="origin"
                target="_blank"
                to="https://khorasan.irannsr.org/fa/trade_unit/2860078/swd_id/105030/اعضای-حقوقی-پیشرو-ترابر-مهیار-شرق.html"
              >
                <img
                  referrerPolicy="origin"
                  src="/license/irannsr-logo.png"
                  alt="نظام صنفی یارانه ای"
                  className="c-pointer w-100 h-100 object-fit-contain"
                  style={{
                    filter:
                      "drop-shadow(1px 1px white) drop-shadow(1px -1px white) drop-shadow(-1px 1px white) drop-shadow(-1px -1px white)",
                  }}
                />
              </Link>
            </Col>
          </div>
        </div>
      </footer>

      <div
        className="d-flex justify-content-center text-center flex-wrap "
        style={{
          width: "100%",
          minHeight: 24,
          backgroundColor: "#4B1483",
        }}
      >
        <Col lg={8} md={8} sm={12}>
          <p className="m-0 p-0" style={{ color: "white", fontSize: 15 }}>
            تمامی حقوق این سایت متعلق به شرکت پیشرو ترابر مهیارشرق می باشد ©
          </p>
        </Col>
      </div>
    </>
  );
};

export default Footer;
